import { useMutation } from 'react-query';

import { APIBaseChronos } from '../hosts';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useStoreSubsetDocIds = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation({
    mutationFn: async ({ matterId, docIds }: { matterId: string; docIds: string[] }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { docIds },
      });

      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/store-doc-ids`, fetchConfig);

      if (!res.ok) {
        throw new Error('Failed to store doc IDs');
      }

      return res.json() as Promise<{ queryKey: string; docIdCount: number }>;
    },
  });
};
